import { SPINESIM_MODALITIES } from "../enums/MedicalImagesEnum";

const REMOTE_MEDICAL_MODALITIES = new Set([
  SPINESIM_MODALITIES.DX,
  SPINESIM_MODALITIES.CT,
  SPINESIM_MODALITIES.MR,
]);

export const getRemoteMedicalViewState = ({
  modality,
  views = [],
  isLocalLoading = false,
  isRemoteRenderConnected = false,
  isRemoteRenderLoading = false,
}) => {
  const hasViews = views.length > 0;
  const isRemoteMedicalModality = REMOTE_MEDICAL_MODALITIES.has(modality);
  const isConnecting =
    isRemoteMedicalModality &&
    !isRemoteRenderConnected &&
    isRemoteRenderLoading;
  const isLoading = isLocalLoading || isConnecting;

  return {
    hasViews,
    isConnecting,
    isLoading,
  };
};
